import React, { useState } from 'react';
import { IconButton, Menu, MenuItem, ListItemIcon, ListItemText } from '@mui/material';
import { MoreCircle, Eye, Key } from 'iconsax-react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

interface StaffContextMenuProps {
  userId: string;
  onResetPassword: (id: string) => void;
}

const StaffContextMenu: React.FC<StaffContextMenuProps> = ({ userId, onResetPassword }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => setAnchorEl(null);

  const handleView = () => {
    navigate(`/users/${userId}`);
    handleClose();
  };
  const handleReset = () => {
    onResetPassword(userId);
    handleClose();
  };

  return (
    <>
      <IconButton size="small" onClick={handleOpen} color="secondary">
        <MoreCircle size={20} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
      >
        <MenuItem onClick={handleView}>
          <ListItemIcon>
            <Eye size={18} />
          </ListItemIcon>
          <ListItemText>{t('actions.view')}</ListItemText>
        </MenuItem>
        <MenuItem onClick={handleReset}>
          <ListItemIcon>
            <Key size={18} />
          </ListItemIcon>
          <ListItemText>{t('staff.send_password_reset')}</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
};

export default StaffContextMenu;
